/* eslint 'jsx-a11y/anchor-is-valid': 'off', 'no-useless-concat': 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import "Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css";
import "Assets/Reports/reportsDefinitions.css";
import "Assets/Reports/greenTable.css";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import SearchInput, { createFilter } from "react-search-input";
import Pagination from "rc-pagination";
import Select from "rc-select";
import localeInfo from "rc-pagination/lib/locale/en_US";
import "rc-pagination/assets/index.css";
import "rc-select/assets/index.css";
import { FaSort } from "react-icons/fa";
import APIutil from "api/APIutils";
import * as url from "api/url";

import { createSvgIcon } from "@mui/material";

const KEYS_TO_FILTERS = [
  "detailDateTimeString",
  "attemptedUsername",
  "completedDateTimeString",
  "source",
];

export const PlayIcon = createSvgIcon(
  <svg
    width="25"
    height="25"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_472_4801"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="25"
    >
      <rect width="25" height="25" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_472_4801)">
      <path
        d="M9.5 16.5L16.5 12L9.5 7.5V16.5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>,
  "Play"
);

class InvalidLogEntry extends Component {
  componentWillMount() {
    this.getReportsList();
  }

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      ReportsList: [],
      currentPagination: 1,
      pagination_records_PerPage: 50,
      IsRedirecttoDataExport: false,
      shortReportList: [],
      exportFormat: "pdf",
      sortedField: "",
      sortDirection: "",
      sort: {
        column: "detailDateTime",
        direction: "asc",
        icon: <FaSort />,
      },
      openModal: false,
      exportButtonSubmitting: false,
    };

    this.searchUpdated = this.searchUpdated.bind(this);
    this.getReportsList = this.getReportsList.bind(this);
    this.generateReport = this.generateReport.bind(this);
  }

  async getReportsList(iden) {
    await APIutil.getDataAPI(url.get_invalid_login)
      .then((res) => {
        // any response that will be returned will be add to the array
        this.setState({ ReportsList: res });
      })
      .catch((error) => {
        throw error;
      });
  }

  desc_or_reportContent = (el, labelText, i, filtered_data) => {
    if (el.typeName === "Data Export") {
      return el.description;
    } else {
      return el.desc.includes("...") ? (
        <div style={{ float: "left" }}>
          <div style={{ float: "left" }}>
            {" "}
            <p className="description_text">
              {el.desc}
              <span
                className="tooltips"
                onClick={(e) => {
                  this.moreTextClick(e);
                }}
              >
                {labelText["More.Text"] !== undefined
                  ? labelText["More.Text"]
                  : "More"}
                <span
                  className={
                    i <= filtered_data.length - 6
                      ? "tooltiptexts"
                      : "topTooltiptexts"
                  }
                >
                  <span className="limitedtooltiptext">{el.longDesc}</span>
                </span>
              </span>
            </p>
          </div>
        </div>
      ) : (
        el.desc
      );
    }
  };

  async generateReport() {
    this.setState({
      exportButtonSubmitting: true,
    });
    const urlLogic =
      this.state.exportFormat === "xlsx"
        ? url.generate_loginAttempt_XLS
        : url.generate_loginAttempt_PDF;
    await APIutil.postDataForLoginAttempt(
      urlLogic,
      this.state.sortedField,
      this.state.sortDirection,
      this.state.searchTerm
    )
      .then((res) => {
        this.setState({
          openModal: false,
          exportButtonSubmitting: false,
        });
        if (res.hasOwnProperty("status") === true && res.status === 200) {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            console.log("IE Browser");
            window.navigator.msSaveOrOpenBlob(
              new Blob([res.data]),
              `AttemptedLoginReport.${this.state.exportFormat}`
            );
          } else {
            const url = decodeURIComponent(
              encodeURIComponent(
                window.URL.createObjectURL(new Blob([res.data]))
              )
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `AttemptedLoginReport.${this.state.exportFormat}`
            );
            document.body.appendChild(link);
            link.click();
          }
        }
      })
      .catch((error) => {
        this.setState({
          exportButtonSubmitting: false,
        });
        throw error;
      });
  }
  render() {
    let filtered_data;
    let pagination_total,
      indexOfLastTodo,
      indexOfFirstTodo = 0;

    let { searchTerm } = this.state;
    const { currentPagination, pagination_records_PerPage } = this.state;
    let labelText = this.props.getLabels;
    let reports_list = (
      <tr>
        <td colSpan="5">{labelText["NoRecords.Text"]}</td>
      </tr>
    );

    if (
      this.state.ReportsList.length !== 0 &&
      Array.isArray(this.state.ReportsList)
    ) {
      let filtered_data_test = this.state.ReportsList.filter(
        createFilter(searchTerm, KEYS_TO_FILTERS)
      );

      pagination_total = filtered_data_test.length;
      indexOfLastTodo = currentPagination * pagination_records_PerPage;
      indexOfFirstTodo = indexOfLastTodo - pagination_records_PerPage;

      if (filtered_data_test.length <= 15) {
        indexOfFirstTodo = 0;
        indexOfLastTodo = 15;
      }

      filtered_data = filtered_data_test.slice(
        indexOfFirstTodo,
        indexOfLastTodo
      );

      if (filtered_data.length !== 0) {
        reports_list = filtered_data.map((el, i) => (
          <tr key={el.id}>
            <td style={border_color} className="width20Percent">
              {el.detailDateTimeString}
            </td>
            <td style={border_color} className="width20Percent">
              {el.attemptedUsername}
            </td>
            <td style={border_color} className="width20Percent">
              {el.previousAttempts
                ? // take out comma separated and put data on a new line
                  el.previousAttempts.split(",").map((item, i) => {
                    return (
                      <div key={i}>
                        {item}
                        <br />
                      </div>
                    );
                  })
                : ""}
            </td>
            <td style={border_color} className="width20Percent">
              {el.completedDateTimeString ? el.completedDateTimeString : ""}
            </td>
            <td style={border_color} className="width28Percent">
              {el.source ? el.source : ""}
            </td>
          </tr>
        ));
      }
    }

    return (
      <>
        <div className="main_container">
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span className="PageTitleBar" style={{ paddingLeft: "0px" }}>
              {labelText["InvalidlogEntry.Text"] !== undefined
                ? labelText["InvalidlogEntry.Text"]
                : "Attempted Logins"}
            </span>
          </div>
          <div className="reports_top_container ">
            <div className="reports_filter_system flexSearchArea">
              <span>
                <SearchInput
                  className="report_search_input"
                  onChange={this.searchUpdated}
                />
              </span>
              <Button
                color="success"
                className="btn-success"
                style={{ height: "25px", width: "100px", border: "none", boxShadow: "none" }}
                onClick={() => {
                  this.setState({
                    openModal: true,
                  });
                }}
                outline={false}
                id="exportAttemptedLoginButton"
              >
                <span className="invalidLogintxt">Export</span>
              </Button>
            </div>
          </div>
          <div className="table_container">
            <Table responsive className="customised_green_table">
              <thead>
                <tr>
                  <th
                    onClick={this.onSort("detailDateTime")}
                    className="link_cursor width20Percent"
                    style={border_color}
                  >
                    {labelText["AttemptedLogin.LastLoginAttempt.Text"] ||
                      "Last Login Attempt"}
                    <span
                      className={this.setArrow("detailDateTime").className}
                    ></span>
                    <FaSort
                      style={{
                        ccolor: "#d5d5d5",
                        display: this.setArrow("detailDateTime").style,
                      }}
                    />
                  </th>
                  <th
                    onClick={this.onSort("attemptedUsername")}
                    className="link_cursor width20Percent"
                    style={border_color}
                  >
                    {labelText["AttemptedLogin.Username.Text"] !== undefined
                      ? labelText["AttemptedLogin.Username.Text"]
                      : "Username"}
                    <span
                      className={this.setArrow("attemptedUsername").className}
                    ></span>{" "}
                    <FaSort
                      style={{
                        ccolor: "#d5d5d5",
                        display: this.setArrow("attemptedUsername").style,
                      }}
                    />{" "}
                  </th>
                  <th
                    className="link_cursor width20Percent"
                    style={border_color}
                  >
                    {labelText["AttemptedLogin.PreviousAttempts.Text"] !==
                    undefined
                      ? labelText["AttemptedLogin.PreviousAttempts.Text"]
                      : "Previous Attempts"}
                  </th>
                  <th
                    onClick={this.onSort("completedDateTime")}
                    className=" link_cursor width20Percent"
                    style={border_color}
                  >
                    {labelText["AttemptedLogin.LockedOutTime.Text"] !==
                    undefined
                      ? labelText["AttemptedLogin.LockedOutTime.Text"]
                      : "Locked Out Time"}
                    <span
                      className={this.setArrow("completedDateTime").className}
                    ></span>
                    <FaSort
                      style={{
                        ccolor: "#d5d5d5",
                        display: this.setArrow("completedDateTime").style,
                      }}
                    />{" "}
                  </th>
                  <th
                    onClick={this.onSort("source")}
                    className="link_cursor width28Percent"
                    style={border_color}
                  >
                    {labelText["AttemptedLogin.UserType.Text"] || "User Type"}{" "}
                    <span className={this.setArrow("source").className}></span>{" "}
                    <FaSort
                      style={{
                        ccolor: "#d5d5d5",
                        display: this.setArrow("source").style,
                      }}
                    />{" "}
                  </th>
                </tr>
              </thead>
            </Table>
          </div>
          {filtered_data !== null &&
          filtered_data !== undefined &&
          filtered_data.length > 3 ? (
            <div
              className="table_container heightAsPercent"
              style={{ overflowY: "auto" }}
            >
              <Table
                responsive
                className="customised_green_table"
                style={{ overflow: "hidden" }}
              >
                <tbody>{reports_list}</tbody>
              </Table>
            </div>
          ) : (
            <div className="table_container heightAsPercent">
              <Table className="customised_green_table">
                <tbody>{reports_list}</tbody>
              </Table>
            </div>
          )}
          <Pagination
            itemRender={textItemRender}
            showTitle={true}
            onChange={this.onChange}
            defaultPageSize={this.state.pagination_records_PerPage}
            current={this.state.currentPagination}
            showTotal={(total, range) =>
              `(Viewing ${range[0]} - ${range[1]} of ${total})   `
            }
            total={pagination_total}
            selectComponentClass={Select}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            defaultCurrent={3}
            pageSizeOptions={["50", "100", "150", "200"]}
            locale={localeInfo}
          />{" "}
          <Modal
            fade={false}
            isOpen={this.state.openModal}
            className="modal-LoginAttempt custom-modal"
            style={{ alignContent: "center", justifyContent: "center" }}
          >
            <ModalHeader>
              <span className="PageTitleBar" style={{ paddingLeft: "0px" }}>
                Export Attempted Logins
              </span>
            </ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-md-12">
                  <label htmlFor="report-name" className="col-form-label">
                    Select a file format and click apply
                  </label>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-5" style={{ paddingTop: "10px" }}>
                        <select
                          className="form-control"
                          id="report-format"
                          name="report-format"
                          onChange={(e) => {
                            this.setState({
                              exportFormat: e.target.value,
                            });
                          }}
                          value={this.state.exportFormat}
                        >
                          <option value="pdf">PDF</option>
                          <option value="xlsx">XLSX</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn-gray uniform-button"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    openModal: false,
                  });
                }}
                id="cancelAttemptedLoginButton"
              >
                Cancel
              </Button>
              <Button
                disabled={this.state.exportButtonSubmitting}
                className="btn-success uniform-button"
                onClick={this.generateReport}
                outline={false}
                id="AttemptedLoginButton"
              >
                Apply
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </>
    );
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === "asc"
        ? "desc"
        : "asc"
      : "desc";

    this.setState({
      sortedField: column,
      sortDirection: direction,
    });

    const sortedData = [...this.state.ReportsList].sort((a, b) => {
      // sorting data on specific column
      let d = 0;
      if (direction === 'asc') {
        d = new Date(a.detailDateTime) > new Date(b.detailDateTime) ? -1 : new Date(a.detailDateTime) < new Date(b.detailDateTime) ? 1: 0;
      } else {
        d = new Date(a.detailDateTime) > new Date(b.detailDateTime) ? 1 : new Date(a.detailDateTime) < new Date(b.detailDateTime) ? -1: 0;
      }

      if (column === "detailDateTime") {
        return new Date(a.detailDateTime) - new Date(b.detailDateTime);
      } else if (column === "attemptedUsername") {
          return a.attemptedUsername.localeCompare(b.attemptedUsername) || d;
      } else if (column === "completedDateTime") {
        const dateA = new Date(a.completedDateTime);
        const dateB = new Date(b.completedDateTime);
          return dateA - dateB || d;
      } else if (column === "source") {
          return a.source.localeCompare(b.source) || d;
      }

      return 0;
    });

    if (direction === "desc") {
      sortedData.reverse();
    }

    this.setState({
      sort: {
        column,
        direction,
      },
      ReportsList: sortedData,
    });
  };

  setArrow = (column) => {
    let className = "reports-sort-direction";
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === "asc" ? " asc" : " desc";
      return { style: "none", className: className };
    } else {
      return { style: "initial", className: "" };
    }
  };

  // Search & Pagination
  onShowSizeChange = (current, pagination_records_PerPage) => {
    this.setState({
      pagination_records_PerPage: parseInt(pagination_records_PerPage),
      currentPagination: 1,
    });
  };

  onChange = (page) => {
    this.setState({ currentPagination: page });
  };

  searchUpdated = (term) => {
    if (term === "") {
      this.setState({ currentPagination: 1 });
    }

    if (this.state.currentPagination > 1) {
      this.setState({ currentPagination: 1 });
    }

    this.setState({ searchTerm: term });
  };
}

const textItemRender = (current, type, element) => {
  if (type === "prev") {
    return "Previous";
  }
  if (type === "next") {
    return "Next";
  }
  return element;
};

const mapStateToProps = (state) => {
  return {
    getLabels:
      state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference,
    userHasFullaccess: state.authService.HasApplicationFullAcess,
  };
};

// Component Styles
const border_color = {
  borderRight: "1px solid #ededed",
};

export default connect(mapStateToProps)(InvalidLogEntry);
